import { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import RecordPerPage from "../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import { setPerPage, setDetails, deleteRecord, fetchList } from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
import AddComponent from "./components/Form/AddComponent";
import EditComponent from "./components/Form/EditComponent";
import { CareerBreadcrumb } from "../../../config/BreadcrumbConfig";
import { toUpperCaseWithUnderscore } from "../../../utils/commonFunctions";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
import ImportComponent from "./components/Form/ImportComponent";
import React from "react";

const moduleInfo = {
  title: "Career",
  permissionKeyPrefix: toUpperCaseWithUnderscore("Careers"),
};

/**
 * Renders the Career Management Module.
 *
 * @return {ReactElement} The rendered Career Management Module.
 */
const CareerManagement: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { perPage } = useAppSelector(state => state.career);
  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [isBookingVisible, setIsBookingVisible] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [deleteValue, setDeleteValue] = useState<any>();

  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);

  return (
    <>
      <ToolBar breadcrumbs={CareerBreadcrumb}>
        <CreateButton
          name="Import"
          action={() => setIsBookingVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
        <CreateButton
          action={() => setIsCreateVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
        <RecordPerPage
          perPage={perPage}
          onChange={(perPageSize: number) => {
            dispatch(setPerPage(perPageSize));
          }}
        />
      </ToolBar>
      <ContentBox>
        <Listing
          moduleInfo={moduleInfo}
          handleEditClick={(data: any) => {
            dispatch(setDetails(data));
            setEditDrawer(true);
          }}
          handleDeleteClick={setDeleteValue}
        />
        <ImportComponent
          titleName={moduleInfo.title}
          open={isBookingVisible}
          close={() => setIsBookingVisible(false)}
        />
        <AddComponent
          titleName={moduleInfo.title}
          open={isCreateVisible}
          close={() => setIsCreateVisible(false)}
        />
        <EditComponent
          titleName={moduleInfo.title}
          open={editDrawer}
          close={() => dispatch(setDetails(null)) && setEditDrawer(false)}
        />
        <DeleteModal
          title={moduleInfo.title}
          deleteValues={deleteValue}
          callApi={deleteRecord}
          close={() => setDeleteValue(null)}
        />
      </ContentBox>
    </>
  );
};

export default CareerManagement;
